import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import Pagination10 from '../Pagination10';
import useDefaultModal from '../hooks/useDefaultModal';
import useConfirmModal from '../hooks/useConfirmModal';
import DefaultModal from './DefaultModal';
import ConfirmModal from './ConfirmModal';
import usePagination10 from '../hooks/usePagination10';
import VinculoModal from './VinculoModal';

function VinculosModal({ show, onClose, usuario }) {
  const [Vinculos, setVinculos] = useState([]);
  const [atualizar, setAtualizar] = useState(false);
  const [selectedVinculo, setSelectedVinculo] = useState(null);
  const [showVinculoModal, setShowVinculoModal] = useState(false);
  const [editingVinculo, setEditingVinculo] = useState(null);
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();
  const totalItems = Vinculos.length;
  const { setPagination } = usePagination10(totalItems);
  const displayedUsuarios = Vinculos.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  useEffect(() => {
    if (!show || !usuario?.cpf) {
      setVinculos([]);
      return;
    }
    axios
      .get(`${API_BASE_URL.VINCULO}/cpf`, {
        params: { cpf: usuario.cpf },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {
        setVinculos(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter registros:', error);
      });
  }, [usuario, token, atualizar, show]);

  useEffect(() => {
    if (
      selectedVinculo &&
      !displayedUsuarios.find(
        v => v.idEntidade === selectedVinculo.idEntidade && v.cpf === selectedVinculo.cpf
      )
    ) {
      setSelectedVinculo(null);
    }
  }, [displayedUsuarios, selectedVinculo]);

  const handleRowClick = vinculo => {
    setSelectedVinculo(
      selectedVinculo &&
        selectedVinculo.idEntidade === vinculo.idEntidade &&
        selectedVinculo.cpf === vinculo.cpf
        ? null
        : vinculo
    );
  };

  const handleCreateVinculo = () => {
    setEditingVinculo(null);
    setShowVinculoModal(true);
  };

  const handleEditVinculo = () => {
    if (selectedVinculo) {
      setEditingVinculo(selectedVinculo);
      setShowVinculoModal(true);
    }
  };

  const handleVinculoSuccess = () => {
    setShowVinculoModal(false);
    setEditingVinculo(null);
    setAtualizar(!atualizar);
    showDefaultModal(
      'success',
      editingVinculo
        ? 'Vínculo atualizado com sucesso!'
        : 'Vínculo criado com sucesso!'
    );
  };

  const handleVinculoClose = () => {
    setShowVinculoModal(false);
    setEditingVinculo(null);
  };

  function handleDelete(usuarioToDelete) {
    showConfirmModal('delete', () => handleConfirmDelete(usuarioToDelete));
  }

  function handleConfirmDelete(usuarioToDelete) {
    axios
      .delete(
        `${API_BASE_URL.VINCULO}/delete/${usuarioToDelete.cpf}/${usuarioToDelete.idEntidade}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        setAtualizar(!atualizar);
        showDefaultModal('success', 'O registro foi excluído com sucesso!');
      })
      .catch(error => {
        console.error('Erro ao deletar:', error);
        showDefaultModal('error', 'Erro ao excluir o registro');
      });
  }

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: '90vw', height: '90vh' }}
        >
          <div className="modal-content" style={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div
              className="modal-header text-white"
              style={{
                background:
                  'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
                padding: '0.35rem 0.75rem',
                border: 'none',
                flexShrink: 0,
              }}
            >
              <div className="d-flex align-items-center justify-content-between" style={{ width: '100%' }}>
                <h6 className="modal-title mb-0" style={{ fontSize: '0.80rem', lineHeight: 1 }}>
                  <i className="bi bi-link-45deg me-2"></i>
                  Vinculação de Usuários - {usuario?.nome || ''}
                </h6>
                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-link text-white p-0 mb-0"
                    onClick={onClose}
                    title="Fechar"
                    style={{ fontSize: '1rem', textDecoration: 'none' }}
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-body" style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', padding: '0.75rem' }}>
              <div className="d-flex gap-2 flex-wrap mb-2" style={{ flexShrink: 0 }}>
                <button
                  className="btn btn-success btn-sm d-inline-flex align-items-center"
                  onClick={handleCreateVinculo}
                  title="Criar novo vínculo"
                >
                  <i className="bi bi-plus-circle me-1"></i>Novo
                </button>
                <button
                  className="btn btn-primary btn-sm"
                  disabled={!selectedVinculo}
                  onClick={handleEditVinculo}
                  title="Editar vínculo selecionado"
                >
                  <i className="bi bi-pencil-square me-1"></i>Editar
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(selectedVinculo)}
                  title="Excluir vínculo"
                  disabled={!selectedVinculo}
                >
                  <i className="bi bi-trash3 me-1"></i>Excluir
                </button>
              </div>
              <div
                style={{
                  flex: 1,
                  overflowY: 'auto',
                  minHeight: 0,
                }}
              >
                <table className="table table-hover table-sm small" style={{ minWidth: '600px' }}>
                  <thead className="sticky-top vinculo-thead">
                    <tr>
                      <th scope="col" style={{ minWidth: '200px' }}>Nome</th>
                      <th scope="col" style={{ minWidth: '150px' }}>Cidade</th>
                      <th scope="col" style={{ minWidth: '60px' }}>UF</th>
                      <th scope="col" style={{ minWidth: '150px' }}>Tipo de Vínculo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedUsuarios.length > 0 ? (
                      displayedUsuarios.map(usu => {
                        const isActiveRow =
                          selectedVinculo &&
                          selectedVinculo.idEntidade === usu.idEntidade &&
                          selectedVinculo.cpf === usu.cpf;
                        return (
                          <tr
                            key={`${usu.idEntidade}-${usu.cpf}`}
                            className={isActiveRow ? 'table-primary' : ''}
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleRowClick(usu)}
                            title={
                              isActiveRow
                                ? 'Vínculo selecionado'
                                : 'Clique para selecionar'
                            }
                          >
                            <td>{usu.entidade.nome}</td>
                            <td>{usu.entidade.logrCidade || '-'}</td>
                            <td>{usu.entidade.logrUf || '-'}</td>
                            <td>{usu.tipo}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          Nenhum vínculo encontrado.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div style={{ flexShrink: 0, paddingTop: '0.5rem' }}>
                <Pagination10 {...setPagination} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <VinculoModal
        show={showVinculoModal}
        onClose={handleVinculoClose}
        onSuccess={handleVinculoSuccess}
        vinculoData={editingVinculo}
        usuario={usuario}
      />
      <ConfirmModal {...setConfirmModal} />
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default VinculosModal;
